import React from 'react';
import { motion } from 'framer-motion';
import tie from '../images/tie.svg';
import linkedin from '../images/linkedin.svg';
import facebook from '../images/facebook.svg';
import max from '../images/max.jpg';
import pin from '../images/pin.svg';
import github from '../images/github.svg';
import resume from '../sumit_resume.docx';

const SideBar = () => {
	var sidebarVariants = {
		initial: {
			x: '-10vw',
			opacity: 0
		},
		visible: {
			x: 0,
			opacity: 1,
			transition: { delay: 0.3, duration: 0.5, type: 'spring' }
		}
	};

	const handleSentEmail = () => window.open('mailto:sumit1523@gmail.com');

	return (
		<motion.div className="sideBar_custom"
			variants={sidebarVariants}
			initial='initial'
			animate='visible'
		>
			<img src={max} alt="avatar" className="rounded-circle image_custom" />
			<h3 className='name'><span>{'Sumit'}</span>{'Kumar'}</h3>
			<div className="title bg-gray side_item">{'Frontend Developer'}</div>
			<a href={resume} download="sumit_resume.docx">
				<div className="cv side_item"><img src={tie} alt="resume" className='icon_small' />{'resume'}</div>
			</a>
			<figure className='social_icons'>
				<a href="https://www.facebook.com/sumit.1523/" target="_blank" rel="noopener noreferrer"><img src={facebook} alt="facebook" className='icon_small social_icon' /></a>
				<a href="https://www.linkedin.com/in/sumit1523/"><img src={linkedin} alt="linkedin" className='icon_small social_icon' /></a>
			</figure>
			<div className="contact">
				<div className="location side_item"><img src={pin} alt="pin" className='icon_small  mr-1' />{'Patna, Bihar'}</div>
				<a href="https://github.com/sumit1523?tab=repositories" target="_blank" rel="noopener noreferrer">
					<div className="github side_item">
						<img src={github} alt="git" className='icon_small social_icon mr-1' />
						{'github'}
					</div>
				</a>
				<div className="email_id side_item">{'sumit1523@gmail.com'}</div>
				<div className="phone side_item">{'9206185087 / 9279523907'}</div>
			</div>
			<div className="email side_item mt-6" onClick={handleSentEmail}>{'email me'}</div>
		</motion.div >
	)
};

export default SideBar;